/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Sovereign_Body_1Inputs */

const en_landing_capability_sovereign_body_1 = /** @type {(inputs: Landing_Capability_Sovereign_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for Tier-1 security requirements. Your data stays within your own systems, isolated from public models and third-party training environments.`)
};

/**
* | output |
* | --- |
* | "Built for Tier-1 security requirements. Your data stays within your own systems, isolated from public models and third-party training environments." |
*
* @param {Landing_Capability_Sovereign_Body_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_sovereign_body_1 = /** @type {((inputs?: Landing_Capability_Sovereign_Body_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Sovereign_Body_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_sovereign_body_1(inputs)
});